import { render, staticRenderFns } from "./ActiveSchoolRank.vue?vue&type=template&id=40140e86&scoped=true"
import script from "./ActiveSchoolRank.vue?vue&type=script&lang=js"
export * from "./ActiveSchoolRank.vue?vue&type=script&lang=js"
import style0 from "./ActiveSchoolRank.vue?vue&type=style&index=0&id=40140e86&prod&lang=scss&scoped=true"
import style1 from "./ActiveSchoolRank.vue?vue&type=style&index=1&id=40140e86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40140e86",
  null
  
)

export default component.exports